// extracted by mini-css-extract-plugin
export const inlineCtaBox = "InlineCTABox-module--inline-cta-box--12_b3";
export const content = "InlineCTABox-module--content--2o6am";
export const alignLeft = "InlineCTABox-module--align-left--26Dz7";
export const alignCenter = "InlineCTABox-module--align-center--R8j8_";
export const alignRight = "InlineCTABox-module--align-right--2AP7U";